import { useThemeTransition } from './useThemeTransition';

export function useTheme() {
  return useThemeTransition();
}

export { useThemeTransition };
